import { useState, useEffect } from 'react';
import { countries as countriesData } from 'countries-list';

export function useCountries() {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const sortedCountries = Object.values(countriesData)
        .map((c) => c.name)
        .sort((a, b) => a.localeCompare(b));
      setCountries(sortedCountries);
      setLoading(false);
    } catch (err) {
      setError(err.message || 'Failed to load countries');
      setLoading(false);
    }
  }, []);

  return { countries, loading, error };
}

